const searchOpener = document.querySelector(".js-search-bar-open");
const menuOpenerMobile = document.querySelector(".js-anim-search-btn-open");
const searchCloser = document.querySelector(".js-search-bar-close");
const searchWrapper = document.querySelector(".js-search-wrapper");

export function init() {
	if (!searchOpener || !menuOpenerMobile || !searchCloser || !searchWrapper) {
		return;
	}

	searchOpener.addEventListener("click", openSearch);
	menuOpenerMobile.addEventListener("click", openSearch);
	searchCloser.addEventListener("click", closeSearch);
	searchWrapper.addEventListener("click", onDocumentClick);
	document.addEventListener("keydown", onKeydown);

	function onDocumentClick(event) {
		if (!searchWrapper.contains(event.target)) {
			closeSearch();
		}
	}

	function onKeydown(event) {
		if (event.key == "Escape") closeSearch();
	}

	function openSearch() {
		searchWrapper.classList.toggle("is-active");
	}

	function closeSearch() {
		searchWrapper.classList.remove("is-active");
	}
}
